import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-mp-button',
  templateUrl: './mp-button.component.html',
  imports: [
    NgIf,
    TranslateModule,
    NgClass
  ],
  styleUrl: './mp-button.component.scss'
})
export class MpButtonComponent {

  @Input() public type: string = 'button';
  /** 'small' | 'medium' | 'large' | 'largest' | 'icon' */
  @Input() public size: 'small' | 'medium' | 'large' | 'largest' | 'icon' | 'icon-medium' = 'medium';
  /** 'square' | 'circle' */
  @Input() public shape: 'circle' | 'square' = 'square';
  /** '' | 'negative' | 'accent' | 'warning' */
  @Input() public color: '' | 'negative' | 'accent' | 'warning' = '';
  @Input() public customClasses: string = '';
  @Input() public shadowEffect: boolean = false;
  @Input() public faIcon: string;
  @Input() public faIconPosition: 'before' | 'after' = 'before';
  @Input() public label: string;
  @Input() public isLoading: boolean = false;
  @Input() public disabled: boolean;

  @Output() buttonClicked = new EventEmitter<MouseEvent>();

  public sendButtonClicked(event: MouseEvent) {
    if (!this.disabled) {
      this.buttonClicked.emit(event);
    }
  }
}
